import { createSelector } from 'reselect';
import { AppState } from '../store';
import { AuthState } from '../types/auth';

export type UserData = Pick<
AuthState,
'builderId' | 'builder' | 'firstName' | 'lastName' | 'username' | 'isPM' | 'isAdmin' | 'isEnterprise' | 'isManagement' | 'phone' | 'email' | 'send_sms' | 'send_email' | 'userRoleId' | 'isRental'
| 'lock_battery_level_send_email' | 'lock_battery_level_send_sms' | 'lock_offline_send_email' | 'lock_offline_send_sms' | 'post_tour_send_sms' | 'post_tour_send_email' | 'cc_email' | 'send_cc_email'
| 'lock_jam_events_send_email' | 'lock_jam_events_send_sms' | 'send_monthly_report' | 'enterpriseId'
>;

export const selectAuthData = (state: AppState) => state.auth;
export const selectLoading = (state: AuthState) => state.loading;
export const selectPmStatus = (state: AuthState) => state.isPM;
export const selectAdminStatus = (state: AuthState) => state.isAdmin;
export const selectEnterpriseStatus = (state: AuthState) => state.isEnterprise;
export const selectManagementStatus = (state: AuthState) => state.isManagement;
export const selectUsername = (state: AuthState) => state.username;
export const selectBuilderName = (state: AuthState) => state.builder;
export const selectIsRental = (state: AuthState) => state.isRental;
const selectBuilderId = (state: AuthState) => state.builderId;
const selectEnterpriseId = (state: AuthState) => state.enterpriseId;
const selectBuilderQuickbookId = (state: AuthState) => state.builderQuickbookId;

export const selectUserData = createSelector(
  selectAuthData,
  ({
    builderId, builder, isRental, firstName, lastName,
    username, isPM, isAdmin, isManagement, phone, email,
    send_sms, send_email, isEnterprise, userRoleId,
    lock_battery_level_send_email, lock_battery_level_send_sms,
    lock_offline_send_email, lock_offline_send_sms,
    post_tour_send_email, post_tour_send_sms,
    cc_email, send_cc_email,
    lock_jam_events_send_email, lock_jam_events_send_sms, send_monthly_report, enterpriseId
   }): UserData => ({
    builderId,
    builder,
    isRental,
    firstName,
    lastName,
    username,
    isPM,
    isAdmin,
    isEnterprise,
    isManagement,
    enterpriseId,
    phone,
    email,
    send_sms,
    send_email,
    lock_battery_level_send_email,
    lock_battery_level_send_sms,
    lock_offline_send_email,
    lock_offline_send_sms,
    userRoleId,
    post_tour_send_email,
    post_tour_send_sms,
    cc_email,
    send_cc_email,
    lock_jam_events_send_email,
    lock_jam_events_send_sms,
    send_monthly_report
  }),
);

export const selectOauthClients = createSelector(selectAuthData, (auth) => auth.oauthClients);

export const selectBuilderOauthClients = createSelector(selectAuthData, (auth) => auth.builderOauthClients);

export const selectAuthRequestStatus = createSelector(selectAuthData, selectLoading);

export const selectIsPM = createSelector(selectAuthData, selectPmStatus);

export const selectIsAdmin = createSelector(selectAuthData, selectAdminStatus);

export const selectIsEnterprise = createSelector(selectAuthData, selectEnterpriseStatus);

export const selectIsManagement = createSelector(selectAuthData, selectManagementStatus);

export const getBuilderId = createSelector(selectAuthData, selectBuilderId);

export const getEnterpriseId = createSelector(selectAuthData, selectEnterpriseId);

export const getBuilderName = createSelector(selectAuthData, selectBuilderName);

export const getIsRental = createSelector(selectAuthData, selectIsRental);

export const getUsername = createSelector(selectAuthData, selectUsername);

export const getBuilderQuickbookId = createSelector(selectAuthData, selectBuilderQuickbookId);
